export const COMPANY = {
  name: "Mon Serrurier Breton",
  phone: "07 80 93 93 00",
  phoneDigits: "0780939300",
  email: "contact@monserrurierbreton.fr",
  base: "Mont-Dol",
  zones: "Côtes-d'Armor (22) & Ille-et-Vilaine (35)",
  radiusKm: 30,
  googleRating: 4.9,
  googleReviews: 127,
  interventions: 800,
  siret: "100 801 877",
  insurance: "Assurance décennale & responsabilité civile professionnelle",
};

export const PRO_PARTNERS = [
  {
    company: "Les Clés Bretonnes",
    sector: "Conciergerie",
    city: "Saint-Malo · Dinard",
    contact: "Marine L.",
    role: "Responsable conciergerie",
    initials: "LB",
    accent: "from-teal-500 to-teal-700",
    text:
      "Mon Serrurier Breton est notre partenaire depuis nos débuts. Pour gérer un parc de locations courte durée, on a besoin d'un référent unique, joignable même à 23h un dimanche soir quand un voyageur reste dehors. Réactivité parfaite, devis transparents, et une relation humaine que je ne retrouve nulle part ailleurs.",
    badge: "Partenaire conciergerie",
    rating: 5,
  },
  {
    company: "Century 21 — Côte d'Émeraude",
    sector: "Agence immobilière",
    city: "Côte d'Émeraude",
    contact: "Pierre M.",
    role: "Commercial",
    initials: "C21",
    accent: "from-amber-500 to-orange-600",
    text:
      "Pour les rotations locatives et les états des lieux, on a besoin d'interventions rapides et sans surprise sur la facturation. Devis sous 24h, intervention sous 48h, paiement à 30 jours respecté à chaque mission. Nos négociateurs gagnent un temps précieux et nos bailleurs sont rassurés.",
    badge: "Partenaire immobilier",
    rating: 5,
  },
  {
    company: "Ma Conciergerie Bretonne",
    sector: "Conciergerie",
    city: "Côte d'Émeraude",
    contact: "Jessica T.",
    role: "Responsable",
    initials: "MCB",
    accent: "from-emerald-500 to-teal-700",
    text:
      "Avoir un serrurier de confiance change tout dans notre métier. Mon Serrurier Breton intervient toujours avec sérieux, transparence sur les tarifs et un vrai sens du service client. Nos voyageurs sont rassurés, et nous gagnons un temps énorme dans la gestion des imprévus.",
    badge: "Partenaire conciergerie",
    rating: 5,
  },
  {
    company: "Hôtel ★★★ — Saint-Malo",
    sector: "Hôtellerie",
    city: "Saint-Malo",
    contact: "Catherine D.",
    role: "Directrice d'établissement",
    initials: "HSM",
    accent: "from-slate-700 to-slate-900",
    text:
      "Quand un client se retrouve enfermé dehors à 1h du matin, ou qu'une clé reste coincée dans le canon avant l'arrivée d'un groupe, on ne peut pas se permettre d'attendre. Mon Serrurier Breton intervient en 30 minutes avec une discrétion totale. C'est devenu un réflexe à la réception.",
    badge: "Partenaire hôtellerie",
    rating: 5,
  },
];


// =============================================================
// B2B AUDIENCE LANDING PAGES — SEO long-tail, drives /serrurier-{audience}
// =============================================================
export const PRO_AUDIENCES = [
  {
    slug: "hoteliers",
    keyword: "hôteliers",
    h1: "Serrurier pour hôteliers en Bretagne",
    metaTitle: "Serrurier pour hôtels — Saint-Malo, Dinard, Cancale | Mon Serrurier Breton",
    metaDescription:
      "Serrurier dédié hôteliers et résidences de tourisme à Saint-Malo, Dinard, Dinan, Cancale et toute la Côte d'Émeraude. Astreinte 24/7, ouverture de chambres, dépannage clients en 30 min, devis cadre. Bretagne 22 & 35.",
    eyebrow: "Hôtellerie & résidences de tourisme",
    accent: "from-amber-500 to-orange-600",
    accentText: "text-orange-600",
    hero: {
      lead: "Vos clients restent dehors à 1h du matin ? Une clé reste bloquée dans le canon avant l'arrivée d'un groupe ? Nous sommes le serrurier de référence des hôtels, gîtes et résidences de tourisme sur Saint-Malo, Dinard, Cancale et toute la Côte d'Émeraude — intervention sous 30 minutes, discrétion totale.",
      heroCities: ["Saint-Malo", "Dinard", "Cancale", "Dinan"],
    },
    keywords: [
      "serrurier hôtel Saint-Malo",
      "serrurier hôtel Dinard",
      "serrurier urgence hôtel Bretagne",
      "ouverture chambre hôtel nuit",
      "dépannage serrure hôtel Cancale",
    ],
    useCases: [
      {
        t: "Client bloqué hors de sa chambre",
        d: "Voyageur enfermé dehors à 23h, clé magnétique HS, badge perdu : intervention discrète sous 30 min, accord avec la réception, aucun dérangement pour les autres clients.",
      },
      {
        t: "Cylindre HS avant un check-in groupe",
        d: "Avant l'arrivée d'un séminaire ou d'un groupe touristique, un cylindre bloqué peut bloquer 5 chambres. Nous intervenons en priorité absolue, remplacement express, organigramme préservé.",
      },
      {
        t: "Sécurisation après dégradation",
        d: "Tentative d'effraction ou dégradation par un client : sécurisation immédiate, blindage temporaire si nécessaire, devis chiffré pour votre assurance hôtelière sous 24h.",
      },
      {
        t: "Maintenance préventive saisonnière",
        d: "Avant chaque saison touristique, audit complet des fermetures, lubrification, remplacement des cylindres usés. Évite les pannes en pleine saison estivale.",
      },
    ],
    services: [
      "Ouverture de chambres et suites 24h/24",
      "Remplacement express de cylindres et serrures électroniques",
      "Maintenance préventive avant saison",
      "Gestion d'organigrammes hôteliers (passe général, passe étage, clé chambre)",
      "Sécurisation après dégradation client",
      "Coffres-forts et serrures de minibars",
      "Boîtes à clés extérieures pour check-in autonome",
      "Audit sécurité des accès du personnel",
    ],
    cities: [
      "saint-malo",
      "dinard",
      "cancale",
      "dinan",
      "saint-briac-sur-mer",
      "saint-lunaire",
      "saint-jacut-de-la-mer",
      "saint-cast-le-guildo",
      "lancieux",
      "pleurtuit",
      "la-richardais",
      "ploubalay",
      "beaussais-sur-mer",
      "matignon",
      "plancoet",
      "crehen",
      "plelan-le-petit",
      "tregon",
      "languenan",
      "dol-de-bretagne",
      "mont-dol",
      "le-vivier-sur-mer",
      "cherrueix",
      "saint-broladre",
      "hirel",
      "saint-benoit-des-ondes",
      "saint-suliac",
      "saint-guinoux",
      "la-fresnais",
      "baguer-pican",
      "baguer-morvan",
      "epiniac",
      "roz-sur-couesnon",
      "pleine-fougeres",
      "la-boussac",
    ],
    faq: [
      {
        q: "Intervenez-vous la nuit dans les hôtels de Saint-Malo intra-muros ?",
        a: "Oui — intervention 24h/24 dans tous les hôtels de Saint-Malo, y compris intra-muros, et sur toute la Côte d'Émeraude. Nous arrivons en moyenne en 25 minutes depuis notre base de Mont-Dol. Discrétion totale, accès direct par la réception sans déranger les autres clients.",
      },
      {
        q: "Pouvez-vous gérer un organigramme hôtelier complet ?",
        a: "Oui — conception, fabrication et maintenance d'organigrammes pour hôtels et résidences : passe général directeur, passes étages, clés chambres, accès personnels (femme de chambre, maintenance). Remplacement partiel possible en cas de perte de clé maître sans devoir tout refaire.",
      },
      {
        q: "Quels tarifs pour un hôtel à Saint-Malo ou Dinard ?",
        a: "Nous établissons un devis cadre annuel avec grille négociée (déplacements, mains-d'œuvre, fournitures à prix négociés). Le ticket moyen est inférieur de 20-30 % par rapport à un appel ponctuel. Facturation à 30 jours fin de mois, attestations sur demande.",
      },
      {
        q: "Travaillez-vous avec les chaînes hôtelières ?",
        a: "Oui — nous intervenons aussi bien pour les hôtels indépendants que pour les établissements de chaînes (Best Western, Logis, Mercure, Ibis…) sur la Côte d'Émeraude. Procédures de validation et reporting compatibles avec les directions régionales.",
      },
      {
        q: "Et pour les résidences de tourisme et locations courte durée ?",
        a: "Idem — boîtes à clés sécurisées, serrures à code reprogrammables, gestion à distance, dépannage clients 24/7. Voir aussi notre offre dédiée aux conciergeries.",
      },
    ],
    partner: 3, // Hôtel ★★★ — Saint-Malo (index in PRO_PARTNERS)
  },
  {
    slug: "syndics-coproprietes",
    keyword: "syndics & copropriétés",
    h1: "Serrurier pour syndics et copropriétés",
    metaTitle: "Serrurier syndic & copropriété — Dinard, Saint-Malo, Dinan | Mon Serrurier Breton",
    metaDescription:
      "Serrurier dédié syndics et conseils syndicaux : parties communes, BAL, halls d'entrée, parkings, urgences résidents 24/7 sur Saint-Malo, Dinard, Dinan, Cancale et toute la Bretagne (22 & 35). Devis cadre, audits annuels.",
    eyebrow: "Syndics de copropriété & conseils syndicaux",
    accent: "from-teal-500 to-teal-700",
    accentText: "text-teal-700",
    hero: {
      lead: "Serrurier de confiance pour syndics et conseils syndicaux sur Saint-Malo, Dinard, Dinan et toute la côte d'Émeraude. Parties communes, halls d'entrée, BAL, parkings, urgences résidents 24/7 — devis cadre annuel et facturation pro à 30 jours.",
      heroCities: ["Dinard", "Saint-Malo", "Dinan", "Pleurtuit"],
    },
    keywords: [
      "serrurier syndic Saint-Malo",
      "serrurier copropriété Dinard",
      "serrurier parties communes Dinan",
      "remplacement BAL copropriété 35",
      "serrurier hall d'entrée Côte Émeraude",
    ],
    useCases: [
      {
        t: "Hall d'entrée bloqué le lundi matin",
        d: "Cylindre forcé par un voyou, badge HS, ferme-porte cassé : nous intervenons en moins d'une heure pour rétablir l'accès des résidents et sécuriser le hall.",
      },
      {
        t: "Refonte d'un organigramme après perte de passe",
        d: "Quand un trousseau de passes disparaît, on doit tout reprendre. Nous gérons la conception, le remplacement progressif des cylindres et l'identification de chaque clé par lot et par étage.",
      },
      {
        t: "Réfection des BAL en série",
        d: "Boîtes aux lettres vétustes ou forcées : remplacement par lot avec serrures normalisées La Poste, étiquetage harmonisé, remise des clés au syndic et listing nominatif.",
      },
      {
        t: "Audit annuel pour conseil syndical",
        d: "Visite complète de la résidence (halls, accès parking, locaux poubelles, locaux vélos), rapport PDF chiffré pour présentation en AG, recommandations priorisées.",
      },
    ],
    services: [
      "Sécurisation halls d'entrée & accès parkings",
      "Remplacement et organisation BAL collectives",
      "Gestion d'organigrammes copropriétés (passes généraux, passes étages)",
      "Réparation ferme-portes & groom",
      "Cylindres anti-effraction A2P sur parties communes",
      "Audits annuels avec rapport PDF",
      "Astreinte téléphonique pour urgences résidents",
      "Mise en sécurité après tentative d'effraction",
    ],
    cities: [
      "saint-malo",
      "dinard",
      "dinan",
      "pleurtuit",
      "la-richardais",
      "saint-briac-sur-mer",
      "saint-lunaire",
      "lancieux",
      "ploubalay",
      "beaussais-sur-mer",
      "saint-jacut-de-la-mer",
      "matignon",
      "saint-cast-le-guildo",
      "plancoet",
      "crehen",
      "cancale",
      "plelan-le-petit",
      "tregon",
      "languenan",
      "dol-de-bretagne",
      "mont-dol",
      "le-vivier-sur-mer",
      "cherrueix",
      "saint-suliac",
      "saint-benoit-des-ondes",
      "hirel",
    ],
    faq: [
      {
        q: "Acceptez-vous les paiements à 30 ou 45 jours fin de mois ?",
        a: "Oui — nous gérons la facturation pro avec TVA, BAT, paiement à 30 jours fin de mois (45 sur acceptation). Compatibles avec les principaux logiciels de gestion (Vilogi, Gercop, ICS, Sépio…). Attestations sur demande pour vos comptables.",
      },
      {
        q: "Pouvez-vous intervenir sur plusieurs immeubles d'un même syndic ?",
        a: "Absolument — c'est notre cœur de métier B2B. Un référent unique gère votre parc complet (Saint-Malo, Dinard, Dinan…), avec un fichier centralisé par immeuble, historique des interventions et organigrammes archivés.",
      },
      {
        q: "Et pour une urgence résident le week-end ?",
        a: "Une ligne d'astreinte dédiée pour vos gardiens et conseils syndicaux : appel priorisé, intervention sous 30 min sur 22 et 35, facturation directe au syndic (jamais au résident sans accord préalable).",
      },
      {
        q: "Comment se déroule un audit de copropriété ?",
        a: "1) Visite complète sur site (1-2h selon taille) — halls, paliers, accès techniques, BAL, parkings. 2) Rapport PDF avec photos et chiffrages priorisés (urgences, court terme, moyen terme). 3) Présentation en AG sur demande.",
      },
      {
        q: "Travaillez-vous avec les principaux syndics de Saint-Malo et Dinard ?",
        a: "Oui — nous intervenons en sous-traitance ou en partenariat direct pour plusieurs cabinets de syndic indépendants et nationaux sur la Côte d'Émeraude. Références communicables sur demande.",
      },
    ],
    partner: 0, // Les Clés Bretonnes (placeholder, syndic-relevant)
  },
  {
    slug: "agences-immobilieres",
    keyword: "agences immobilières",
    h1: "Serrurier pour agences immobilières",
    metaTitle: "Serrurier agence immobilière — Côte d'Émeraude, Saint-Malo, Dinard | Mon Serrurier Breton",
    metaDescription:
      "Serrurier dédié aux agences immobilières et bailleurs sur la Côte d'Émeraude (Saint-Malo, Dinard, Dinan, Cancale). Rotations locatives, états des lieux, mises en sécurité, devis 24h, facturation pro à 30 jours.",
    eyebrow: "Agences immobilières & bailleurs",
    accent: "from-blue-600 to-indigo-700",
    accentText: "text-blue-700",
    hero: {
      lead: "Pour les agences immobilières et bailleurs de la Côte d'Émeraude : remise en état entre locataires, ouverture de portes pour états des lieux, changement de cylindres systématique en rotation locative — devis sous 24h, intervention sous 48h sur Saint-Malo, Dinard, Dinan et toute la Bretagne 22 / 35.",
      heroCities: ["Saint-Malo", "Dinard", "Dinan", "Cancale"],
    },
    keywords: [
      "serrurier agence immobilière Saint-Malo",
      "serrurier rotation locative Dinard",
      "serrurier état des lieux Bretagne",
      "changement cylindre location 35",
      "serrurier bailleur Côte Émeraude",
    ],
    useCases: [
      {
        t: "Locataire injoignable, état des lieux à faire",
        d: "Nous intervenons en accord avec votre négociateur pour ouvrir le logement (procédure légale respectée), sécuriser après l'état des lieux, et changer le cylindre si demandé par le bailleur.",
      },
      {
        t: "Rotation locative — sécurité du nouveau locataire",
        d: "Changement systématique du cylindre entre deux locataires : un nouveau jeu de clés numéroté est remis avec PV. Service forfaitaire négocié pour vos rotations récurrentes.",
      },
      {
        t: "Mise en sécurité après dégradation",
        d: "Logement vandalisé ou cambriolé pendant la vacance : sécurisation immédiate, photos chiffrées pour assurance, devis de remise en état sous 24h pour le bailleur.",
      },
      {
        t: "Logement vide en travaux",
        d: "Logement en cours de rénovation : sécurisation provisoire des accès (cylindre temporaire, blindage léger), gestion des accès artisans avec organigramme dédié.",
      },
    ],
    services: [
      "Changement de cylindre en rotation locative (forfait négocié)",
      "Ouverture de porte pour état des lieux (procédure légale)",
      "Sécurisation logements vides ou en travaux",
      "Remise en état après cambriolage / dégradation",
      "Gestion d'accès chantiers (organigramme provisoire)",
      "Audits sécurité pour mise en location",
      "Cylindres haute sécurité pour bailleurs sensibles",
      "Reproduction de clés pour multi-locataires",
    ],
    cities: [
      "saint-malo",
      "dinard",
      "dinan",
      "cancale",
      "pleurtuit",
      "la-richardais",
      "saint-briac-sur-mer",
      "saint-lunaire",
      "saint-jacut-de-la-mer",
      "lancieux",
      "ploubalay",
      "beaussais-sur-mer",
      "matignon",
      "saint-cast-le-guildo",
      "plancoet",
      "crehen",
      "plelan-le-petit",
      "tregon",
      "languenan",
      "dol-de-bretagne",
      "mont-dol",
      "le-vivier-sur-mer",
      "cherrueix",
      "saint-suliac",
      "saint-benoit-des-ondes",
      "hirel",
    ],
    faq: [
      {
        q: "Quel délai pour intervenir entre deux locataires ?",
        a: "48h en standard, 24h en urgence — partout sur Saint-Malo, Dinard, Dinan et la Côte d'Émeraude. Coordination directe avec votre gestionnaire ou négociateur, prise de RDV en ligne possible.",
      },
      {
        q: "Comment fonctionne le changement de cylindre forfaitaire ?",
        a: "Tarif fixe négocié dans le devis cadre : déplacement + cylindre standard + main-d'œuvre + remise des clés numérotées avec PV signé. Aucun supplément sauf besoin spécifique (cylindre A2P, débrouillage).",
      },
      {
        q: "Acceptez-vous d'être référencé chez un bailleur institutionnel ?",
        a: "Oui — nous fournissons les pièces administratives nécessaires (Kbis, attestation décennale, attestation URSSAF, RIB) pour référencement chez les bailleurs sociaux, foncières et institutionnels intervenant sur 22 et 35.",
      },
      {
        q: "Et pour les diagnostics serrurerie avant mise en location ?",
        a: "Sur demande — visite préalable du logement, vérification des fermetures (porte d'entrée, BAL, dépendances), rapport pour le dossier locataire, recommandations pour mise aux normes.",
      },
      {
        q: "Pouvez-vous gérer les sinistres en remboursement assurance ?",
        a: "Oui — facture détaillée acceptée par toutes les compagnies (MAIF, Macif, Groupama, Allianz, AXA, Crédit Mutuel…), coordination directe avec l'expert assurance si demandé, photos avant/après archivées.",
      },
    ],
    partner: 1, // Century 21
  },
  {
    slug: "conciergeries",
    keyword: "conciergeries & locations courte durée",
    h1: "Serrurier pour conciergeries & locations courte durée",
    metaTitle: "Serrurier conciergerie & location courte durée — Côte d'Émeraude | Mon Serrurier Breton",
    metaDescription:
      "Serrurier de confiance des conciergeries Airbnb, Booking et locations saisonnières sur Saint-Malo, Dinard, Cancale, Dinan : boîtes à clés, serrures à code, dépannage voyageurs 24/7. Bretagne 22 & 35.",
    eyebrow: "Conciergeries & locations courte durée",
    accent: "from-emerald-500 to-teal-700",
    accentText: "text-emerald-700",
    hero: {
      lead: "Vos voyageurs Airbnb / Booking se retrouvent dehors à 22h ? Une boîte à clés sabotée ? Un cylindre bloqué entre deux check-ins ? Nous sommes le serrurier dédié des conciergeries et bailleurs courte durée sur Saint-Malo, Dinard, Cancale, Dinan et toute la Côte d'Émeraude — astreinte 24/7, intervention en 30 minutes.",
      heroCities: ["Saint-Malo", "Dinard", "Cancale", "Saint-Cast-le-Guildo"],
    },
    keywords: [
      "serrurier conciergerie Saint-Malo",
      "serrurier Airbnb Dinard",
      "boîte à clés sécurisée Côte Émeraude",
      "serrurier location courte durée Cancale",
      "dépannage voyageur Bretagne",
    ],
    useCases: [
      {
        t: "Voyageur enfermé dehors à 23h",
        d: "Code boîte à clés HS, batterie de la serrure connectée vide, clé perdue par le voyageur : on intervient sous 30 min, on rentre votre client, on sécurise pour la nuit.",
      },
      {
        t: "Boîte à clés sabotée ou crochetée",
        d: "Mise en sécurité immédiate, remplacement par modèle haute sécurité antivol, code reprogrammé. Photos pour votre assurance et votre plateforme.",
      },
      {
        t: "Rotation entre deux check-ins",
        d: "Cylindre HS découvert au check-out, prochain voyageur dans 4h : intervention express, remplacement immédiat, codes mis à jour sur votre PMS / canal.",
      },
      {
        t: "Setup d'un nouveau bien locatif",
        d: "Installation complète : serrure connectée ou à code, boîte à clés extérieure, cylindre A2P pour la sécurité du linge et matériel, organigramme propriétaire / ménage.",
      },
    ],
    services: [
      "Boîtes à clés sécurisées (installation et remplacement)",
      "Serrures à code mécaniques et électroniques",
      "Dépannage voyageurs 24/7 sur tout votre parc",
      "Remplacement express de cylindre entre check-ins",
      "Cylindres haute sécurité pour biens premium",
      "Organigramme propriétaire / conciergerie / ménage",
      "Setup complet pour nouveau bien Airbnb / Booking",
      "Audit sécurité d'un parc avant saison",
    ],
    cities: [
      "saint-malo",
      "dinard",
      "cancale",
      "saint-cast-le-guildo",
      "saint-briac-sur-mer",
      "saint-lunaire",
      "saint-jacut-de-la-mer",
      "lancieux",
      "pleurtuit",
      "la-richardais",
      "ploubalay",
      "beaussais-sur-mer",
      "dinan",
      "matignon",
      "plancoet",
      "crehen",
      "plelan-le-petit",
      "tregon",
      "languenan",
      "dol-de-bretagne",
      "mont-dol",
      "le-vivier-sur-mer",
      "cherrueix",
      "saint-suliac",
      "saint-benoit-des-ondes",
      "hirel",
    ],
    faq: [
      {
        q: "Pouvez-vous gérer un parc Airbnb sur plusieurs communes ?",
        a: "Oui — nous gérons des parcs jusqu'à 80+ biens répartis entre Saint-Malo, Dinard, Cancale et la côte. Référent unique, fichier centralisé par bien (adresse, type de serrure, code BAC, accès propriétaire), facturation mensuelle consolidée.",
      },
      {
        q: "Que faire en cas d'urgence le soir ou le week-end ?",
        a: "Une ligne d'astreinte dédiée pour vos gestionnaires : appel priorisé, intervention sous 30 min sur 22 / 35, contact direct avec le voyageur si vous le souhaitez. Aucune surfacturation cachée — majorations réglementaires uniquement (annoncées avant intervention).",
      },
      {
        q: "Recommandez-vous serrures à code ou boîtes à clés ?",
        a: "Pour un parc de 5+ biens : serrures à code reprogrammables (autonomie d'1 à 2 ans). Pour les biens uniques ou anciens : boîte à clés haute sécurité fixée au mur. On vous accompagne dans le choix selon votre canal (Airbnb, Booking, Abritel) et la typologie du bien.",
      },
      {
        q: "Quels tarifs pour une conciergerie ?",
        a: "Devis cadre annuel avec grille négociée : déplacement forfait, mains d'œuvre dégressive selon volume, fournitures à prix négociés. Le ticket moyen est inférieur de 25-35 % par rapport à un appel ponctuel.",
      },
      {
        q: "Pouvez-vous intervenir sur des biens premium / villas Côte d'Émeraude ?",
        a: "Oui — installation de cylindres A2P 3 étoiles, serrures multipoints connectées, boîtes à clés haute sécurité antivol. Sécurité renforcée pour biens à fort tarif locatif (mobilier, électroménager, œuvres).",
      },
    ],
    partner: 0, // Les Clés Bretonnes
  },
];

export const REVIEWS = [
  {
    name: "David",
    city: "",
    rating: 5,
    date: "19 novembre 2025",
    text:
      "Un grand merci pour ce dépannage ! Après avoir tenté d'ouvrir ma porte moi-même sans succès, j'ai fait appel à ce professionnel. Rapide, pédagogue et très soigneux, il a réussi à ouvrir la porte sans rien abîmer. Pas de mauvaise surprise sur la facture : le prix final correspondait au devis téléphonique. Un service efficace et transparent comme on en voit peu !",
    service: "Ouverture de porte",
  },
  {
    name: "Franck",
    city: "",
    rating: 5,
    date: "11 novembre 2025",
    text:
      "Service irréprochable ! J'ai contacté ce serrurier en urgence et le résultat est au-delà de mes attentes. Rapidité, efficacité et surtout une grande honnêteté dans les conseils fournis. Le problème a été réglé en un clin d'œil avec un grand professionnalisme. Vous pouvez y aller les yeux fermés : c'est fiable, propre et très sympathique !",
    service: "Dépannage urgence",
  },
  {
    name: "Camille",
    city: "",
    rating: 5,
    date: "19 septembre 2025",
    text:
      "Un immense merci pour l'intervention ultra-rapide ce samedi matin ! Arrivé en moins de 30 minutes pour une clé cassée, le technicien a été aussi efficace que sympathique. Travail très soigné et, point crucial, le devis annoncé au téléphone a été parfaitement respecté. Une expérience 100 % positive que je recommande sans hésiter !",
    service: "Clé cassée",
  },
  {
    name: "Sophia",
    city: "",
    rating: 5,
    date: "20 août 2025",
    text:
      "Professionnel au top. Malgré l'heure très tardive, le kilométrage parcouru, la porte blindée et ma fille jeune et inquiète d'avoir passé toutes ces heures en dehors de son appartement, le dépannage a été fait vite, bien et sans abus. Merci à ce professionnel que je recommande vivement.",
    service: "Porte blindée",
  },
  {
    name: "Catherine",
    city: "",
    rating: 5,
    date: "14 janvier 2025",
    text:
      "Délai d'intervention très positif, bonne communication, intervenant très professionnel et très rapide. Je recommande fortement cette entreprise.",
    service: "Intervention rapide",
  },
  {
    name: "Jessica",
    city: "",
    rating: 5,
    date: "2 janvier 2025",
    text:
      "Excellent. Je ne peux que conseiller cette équipe. Une équipe à l'écoute, professionnelle, ponctuelle, efficace et rapide. Travail propre et soigné.",
    service: "Travail soigné",
  },
];

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_ca59ba16-82a4-46e9-90eb-599f1deb29d0/artifacts/09ffie76_Blue%20and%20Yellow%20Simple%20Real%20Estate%20Logo%20%283%29_edited.avif";

export const LOGO_FOOTER_URL =
  "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/73fnv6p3_Sans%20titre.png";

export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/1wv5j260_Capture%20d%E2%80%99e%CC%81cran%202026-05-05%20a%CC%80%2022.56.53.png";

export const HERO_IMAGE_MOBILE =
  "https://static.prod-images.emergentagent.com/jobs/ca59ba16-82a4-46e9-90eb-599f1deb29d0/images/1deb1ab56f033ee50e994942f5b1f0205ecbfc17c4f7fc1d8231235011448aa8.png";

export const SERVICE_IMAGE_1 =
  "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/per8ux25_Capture%20d%E2%80%99e%CC%81cran%202026-05-05%20a%CC%80%2023.20.50.png";

export const SERVICE_IMAGE_2 =
  "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/5jve052a_francois%20serrurier.webp";

export const TRUSTED_BRANDS = [
  "PICARD",
  "VACHETTE",
  "ASSA ABLOY",
  "BRICARD",
  "HERACLES",
  "MUL-T-LOCK",
  "FICHET",
];

export const SERVICES = [
  {
    id: "ouverture-porte",
    title: "Ouverture de porte",
    short: "Porte claquée ou verrouillée, ouverture fine sans dégât.",
    details:
      "Intervention en moyenne sous 30 minutes. Technique d'ouverture fine privilégiée pour préserver votre serrure. Porte claquée, porte fermée à clé, clé perdue ou cassée à l'intérieur : nous intervenons 24h/24.",
    icon: "DoorOpen",
  },
  {
    id: "changement-serrure",
    title: "Changement de serrure & cylindre",
    short: "Toutes marques, tous modèles, haute sécurité A2P.",
    details:
      "Remplacement de serrure standard ou multipoints, changement de cylindre toutes marques (Picard, Vachette, Bricard, Héraclès, Assa Abloy). Mise en sécurité après perte de clés ou déménagement.",
    icon: "KeyRound",
  },
  {
    id: "mise-en-securite",
    title: "Mise en sécurité après effraction",
    short: "Remise en état rapide de porte, serrure et verrou.",
    details:
      "Après tentative d'effraction ou cambriolage, nous intervenons en urgence pour rétablir la sécurité de votre logement : réparation ou remplacement de la porte, serrure, verrou, cadre.",
    icon: "ShieldAlert",
  },
  {
    id: "blindage-porte",
    title: "Blindage de porte & éléments anti-effraction",
    short: "Poignée blindée, cornière anti-pince, cylindre renforcé.",
    details:
      "Installation d'éléments de sécurité : blindage de porte, poignée blindée, cornière anti-pince, cylindre haute sécurité. Audit complet de la sécurité de votre domicile.",
    icon: "Shield",
  },
  {
    id: "boite-aux-lettres",
    title: "Boîte aux lettres",
    short: "Ouverture et installation de serrures de BAL.",
    details:
      "Ouverture en cas de perte de clé, remplacement de la serrure, installation de serrures neuves sur boîtes aux lettres individuelles ou collectives.",
    icon: "Mailbox",
  },
  {
    id: "conseils",
    title: "Conseils anti-effraction",
    short: "Audit gratuit & optimisation de la sécurité.",
    details:
      "Diagnostic personnalisé, recommandations sur les points faibles de votre logement, devis détaillé et transparent pour sécuriser efficacement votre habitation.",
    icon: "BadgeCheck",
  },
];

export const CITIES = [
  {
    slug: "ploubalay",
    name: "Ploubalay",
    postal: "22650",
    departement: "Côtes-d'Armor",
    dept: "22",
    distance: 45,
    lead:
      "Ploubalay (commune déléguée de Beaussais-sur-Mer) fait partie de notre secteur d'intervention historique en Côtes-d'Armor. Nous y intervenons régulièrement pour toute urgence serrurerie, avec les mêmes tarifs et le même sérieux qu'à Mont-Dol.",
    neighbors: ["beaussais-sur-mer", "tregon", "lancieux", "saint-jacut-de-la-mer", "plancoet"],
  },
  {
    slug: "beaussais-sur-mer",
    name: "Beaussais-sur-Mer",
    postal: "22650",
    departement: "Côtes-d'Armor",
    dept: "22",
    distance: 45,
    lead:
      "Beaussais-sur-Mer (regroupant Ploubalay, Trégon et Plessix-Balisson) reste dans notre zone d'intervention régulière en Côtes-d'Armor. Interventions serrurerie 24h/24 pour toute la commune.",
    neighbors: ["ploubalay", "tregon", "lancieux", "saint-jacut-de-la-mer", "plancoet"],
  },
  {
    slug: "dinard",
    name: "Dinard",
    postal: "35800",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 10,
    lead:
      "Station balnéaire prisée, Dinard compte de nombreuses résidences principales, secondaires et commerces. Nous intervenons très régulièrement sur le centre-ville, La Malouine, Saint-Énogat et la Vicomté pour l'ouverture de porte, le changement de serrure et le blindage.",
    neighbors: ["saint-lunaire", "saint-briac-sur-mer", "pleurtuit", "la-richardais", "saint-malo"],
  },
  {
    slug: "saint-malo",
    name: "Saint-Malo",
    postal: "35400",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 20,
    lead:
      "Intra-muros, Paramé, Rothéneuf, Saint-Servan… Saint-Malo est une zone d'intervention régulière pour Mon Serrurier Breton. Ouverture de porte non destructive, cylindres A2P et blindage pour particuliers et commerçants.",
    neighbors: ["saint-jouan-des-guerets", "dinard", "la-richardais", "cancale"],
  },
  {
    slug: "dinan",
    name: "Dinan",
    postal: "22100",
    departement: "Côtes-d'Armor",
    dept: "22",
    distance: 22,
    lead:
      "Cité médiévale de caractère, Dinan regroupe de nombreuses portes anciennes aux serrures spécifiques. Nos artisans maîtrisent les serrures traditionnelles comme les solutions modernes haute sécurité.",
    neighbors: ["lanvallay", "taden", "plelan-le-petit", "plancoet"],
  },
  {
    slug: "saint-jacut-de-la-mer",
    name: "Saint-Jacut-de-la-Mer",
    postal: "22750",
    departement: "Côtes-d'Armor",
    dept: "22",
    distance: 7,
    lead:
      "Sur la presqu'île jacutine, nous intervenons rapidement pour les résidents à l'année et les propriétaires de résidences secondaires, notamment pour la sécurisation de maisons inoccupées.",
    neighbors: ["lancieux", "ploubalay", "beaussais-sur-mer"],
  },
  {
    slug: "lancieux",
    name: "Lancieux",
    postal: "22770",
    departement: "Côtes-d'Armor",
    dept: "22",
    distance: 5,
    lead:
      "Village côtier voisin de notre base, Lancieux bénéficie d'interventions quasi immédiates. Dépannage d'urgence, changement de cylindre, mise en sécurité après effraction.",
    neighbors: ["ploubalay", "saint-jacut-de-la-mer", "beaussais-sur-mer", "saint-briac-sur-mer"],
  },
  {
    slug: "pleurtuit",
    name: "Pleurtuit",
    postal: "35730",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 13,
    lead:
      "Commune dynamique proche de l'aéroport Dinard–Pleurtuit, zone pavillonnaire importante. Nous intervenons sur les portes d'entrée, serrures de garage et boîtes aux lettres.",
    neighbors: ["dinard", "la-richardais", "le-minihic-sur-rance", "saint-briac-sur-mer"],
  },
  {
    slug: "saint-briac-sur-mer",
    name: "Saint-Briac-sur-Mer",
    postal: "35800",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 10,
    lead:
      "Station balnéaire familiale, Saint-Briac-sur-Mer compte de nombreuses résidences secondaires. Notre service de sécurisation avant/après saison est particulièrement apprécié.",
    neighbors: ["saint-lunaire", "dinard", "lancieux", "pleurtuit"],
  },
  {
    slug: "saint-lunaire",
    name: "Saint-Lunaire",
    postal: "35800",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 13,
    lead:
      "Entre Dinard et Saint-Briac, Saint-Lunaire est parfaitement couverte par notre équipe mobile. Interventions d'urgence et rendez-vous programmés.",
    neighbors: ["dinard", "saint-briac-sur-mer", "pleurtuit"],
  },
  {
    slug: "plancoet",
    name: "Plancoët",
    postal: "22130",
    departement: "Côtes-d'Armor",
    dept: "22",
    distance: 14,
    lead:
      "Ville de la vallée de l'Arguenon, Plancoët et ses alentours sont couverts quotidiennement. Dépannage rapide, conseil en sécurité et installation de serrures multipoints.",
    neighbors: ["crehen", "languenan", "plelan-le-petit", "matignon"],
  },
  {
    slug: "matignon",
    name: "Matignon",
    postal: "22550",
    departement: "Côtes-d'Armor",
    dept: "22",
    distance: 17,
    lead:
      "Chef-lieu de canton, Matignon est une zone où nous intervenons régulièrement pour les particuliers et les commerces. Intervention rapide, tarifs transparents.",
    neighbors: ["saint-cast-le-guildo", "plancoet", "crehen"],
  },
  {
    slug: "saint-cast-le-guildo",
    name: "Saint-Cast-le-Guildo",
    postal: "22380",
    departement: "Côtes-d'Armor",
    dept: "22",
    distance: 19,
    lead:
      "Station balnéaire très fréquentée en saison, Saint-Cast-le-Guildo bénéficie de notre service d'urgence 24h/24, notamment pour les portes claquées et pertes de clés de vacanciers.",
    neighbors: ["matignon", "saint-jacut-de-la-mer", "crehen"],
  },
  {
    slug: "crehen",
    name: "Créhen",
    postal: "22130",
    departement: "Côtes-d'Armor",
    dept: "22",
    distance: 10,
    lead:
      "Commune des Côtes-d'Armor à proximité immédiate de Plancoët, Créhen est entièrement couverte par notre service mobile.",
    neighbors: ["plancoet", "languenan", "ploubalay", "matignon"],
  },
  {
    slug: "plelan-le-petit",
    name: "Plélan-le-Petit",
    postal: "22980",
    departement: "Côtes-d'Armor",
    dept: "22",
    distance: 17,
    lead:
      "Bourg animé entre Dinan et Plancoët, nous intervenons ici pour toute urgence serrurerie : ouverture de porte, changement de cylindre, mise en sécurité.",
    neighbors: ["dinan", "plancoet", "languenan"],
  },
  {
    slug: "cancale",
    name: "Cancale",
    postal: "35260",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 30,
    lead:
      "Cité des huîtres, Cancale est dans notre périmètre d'intervention étendu. Dépannage serrurerie pour résidents, professionnels de la restauration et résidences secondaires.",
    neighbors: ["saint-malo", "saint-meloir-des-ondes"],
  },
  {
    slug: "la-richardais",
    name: "La Richardais",
    postal: "35780",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 11,
    lead:
      "En rive droite de la Rance, La Richardais est rapidement accessible depuis notre base de Mont-Dol via la 4-voies. Interventions express et sécurisation de logements.",
    neighbors: ["dinard", "pleurtuit", "le-minihic-sur-rance"],
  },
  {
    slug: "tregon",
    name: "Trégon",
    postal: "22650",
    departement: "Côtes-d'Armor",
    dept: "22",
    distance: 3,
    lead:
      "Commune déléguée de Beaussais-sur-Mer, Trégon fait partie du secteur historique du 22 que nous continuons à desservir régulièrement, avec les mêmes tarifs qu'à Mont-Dol.",
    neighbors: ["ploubalay", "beaussais-sur-mer", "languenan"],
  },
  {
    slug: "languenan",
    name: "Languenan",
    postal: "22130",
    departement: "Côtes-d'Armor",
    dept: "22",
    distance: 13,
    lead:
      "Bourg rural des Côtes-d'Armor, Languenan fait partie intégrante de notre zone d'intervention habituelle.",
    neighbors: ["plancoet", "crehen", "plelan-le-petit", "tregon"],
  },
  {
    slug: "dol-de-bretagne",
    name: "Dol-de-Bretagne",
    postal: "35120",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 3,
    lead:
      "Ancienne cité épiscopale, Dol-de-Bretagne est une commune dynamique de la baie du Mont-Saint-Michel. Nous y intervenons pour les particuliers, les hôtels, les commerces et les résidences secondaires : ouverture de porte, changement de cylindre, blindage, mise en sécurité 24h/24.",
    neighbors: ["mont-dol", "le-vivier-sur-mer", "cancale"],
  },
  {
    slug: "mont-dol",
    name: "Mont-Dol",
    postal: "35120",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 0,
    base: true,
    lead:
      "Mon Serrurier Breton est physiquement basé à Mont-Dol, au pied du célèbre mont, en plein cœur de la baie du Mont-Saint-Michel. Nous sommes vos serruriers de proximité, joignables 24h/24 et intervenant sous 30 minutes en moyenne sur la commune et l'ensemble du secteur 22 & 35.",
    neighbors: ["dol-de-bretagne", "le-vivier-sur-mer"],
  },
  {
    slug: "le-vivier-sur-mer",
    name: "Le Vivier-sur-Mer",
    postal: "35960",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 10,
    lead:
      "Port ostréicole et mytilicole de la baie du Mont-Saint-Michel, Le Vivier-sur-Mer compte de nombreux commerces, restaurants et résidences de bord de mer. Nous y assurons dépannage serrurerie 24h/24, y compris pour les professionnels de la conchyliculture.",
    neighbors: ["dol-de-bretagne", "mont-dol", "cancale"],
  },
  {
    slug: "cherrueix",
    name: "Cherrueix",
    postal: "35120",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 5,
    lead:
      "Village pittoresque de la baie du Mont-Saint-Michel, réputé pour ses chars à voile et le kitesurf, Cherrueix est à quelques minutes de notre atelier. Interventions serrurerie rapides pour résidences principales, secondaires et gîtes.",
    localSeo:
      "Située face à la baie du Mont-Saint-Michel, <strong>Cherrueix</strong> attire chaque année une forte affluence touristique, avec une part importante de résidences secondaires et de locations saisonnières. Cette économie touristique génère des besoins spécifiques en serrurerie : <strong>boîtes à clés pour check-in autonome</strong>, changements réguliers de codes de serrure, sécurisation des biens laissés vacants entre deux locations.\n\nÀ Cherrueix, nous intervenons aussi bien pour les <strong>propriétaires de résidences secondaires</strong> qui découvrent un problème de serrure en arrivant le vendredi soir, que pour les <strong>conciergeries locales</strong> qui gèrent un parc de locations Airbnb / Booking. Notre atelier de Mont-Dol étant à seulement 5 km, nous garantissons une <strong>intervention en 10 à 15 minutes</strong>, un délai précieux quand un voyageur reste bloqué dehors.\n\nNous équipons également les habitations exposées aux vents marins avec des <strong>cylindres en inox et serrures anti-corrosion</strong>, indispensables sur ce littoral. Un vrai savoir-faire local, transparent et sans intermédiaire.",
    neighbors: ["mont-dol", "saint-broladre", "hirel", "le-vivier-sur-mer"],
  },
  {
    slug: "saint-broladre",
    name: "Saint-Broladre",
    postal: "35120",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 5,
    lead:
      "Commune agricole et résidentielle de la baie du Mont-Saint-Michel, Saint-Broladre est juste à côté de Mont-Dol. Dépannage express serrurerie 24h/24 pour particuliers et professionnels.",
    neighbors: ["mont-dol", "cherrueix", "roz-sur-couesnon", "la-boussac"],
  },
  {
    slug: "hirel",
    name: "Hirel",
    postal: "35120",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 10,
    lead:
      "Port ostréicole et mytilicole de la baie, Hirel accueille de nombreux commerces, restaurants et résidences bord de mer. Nous y intervenons pour ouvertures de porte, sécurisation et changements de serrure.",
    localSeo:
      "Village côtier de la baie du Mont-Saint-Michel, <strong>Hirel</strong> vit au rythme des marées et des activités conchylicoles. Cette économie particulière génère une demande serrurerie que peu d'artisans savent traiter : <strong>sécurisation de locaux professionnels de mytiliculteurs et ostréiculteurs</strong>, cylindres résistants à l'air marin sur les hangars et cabines, serrures de portes de chambres froides.\n\nÀ Hirel, nous intervenons aussi pour les habitations privées, principalement pour des <strong>ouvertures d'urgence</strong> (portes claquées lors de balades sur la digue) et le <strong>renforcement de sécurité</strong> avant absence prolongée. Les restaurateurs locaux nous confient également la maintenance annuelle de leurs fermetures — un audit préventif à l'entrée de la saison estivale est souvent la clé pour éviter les pannes en pleine affluence.\n\nDepuis Mont-Dol, Hirel est à 10 km : intervention en <strong>20 minutes maximum</strong>, avec des cylindres inox adaptés au climat marin toujours disponibles dans notre stock.",
    neighbors: ["mont-dol", "saint-benoit-des-ondes", "le-vivier-sur-mer", "cherrueix"],
  },
  {
    slug: "saint-benoit-des-ondes",
    name: "Saint-Benoît-des-Ondes",
    postal: "35114",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 12,
    lead:
      "Village de mytiliculteurs sur la côte de la baie, Saint-Benoît-des-Ondes est dans notre secteur d'intervention rapide. Dépannage serrurerie 24h/24 pour habitations et professionnels de la conchyliculture.",
    localSeo:
      "Commune littorale d'Ille-et-Vilaine, <strong>Saint-Benoît-des-Ondes</strong> est un haut lieu de la mytiliculture bretonne. Le village compte une population résidente stable, complétée par une clientèle touristique en été. La proximité immédiate de la mer impose des contraintes particulières sur les serrures : oxydation accélérée, mécanismes qui se grippent, ressorts qui rouillent.\n\nÀ Saint-Benoît-des-Ondes, nous privilégions systématiquement l'installation de <strong>cylindres et serrures en inox ou traités anti-corrosion</strong>, seul choix vraiment durable en bord de mer. Nos interventions les plus courantes : <strong>maintenance préventive semestrielle</strong> (lubrification, contrôle), remplacement de cylindres oxydés, et urgences classiques (perte de clés, porte claquée).\n\nNotre atelier de Mont-Dol étant à 12 km, nous intervenons en <strong>20 à 25 minutes</strong> sur toute la commune, y compris le hameau du Vivier-est et les fermes isolées. Facture claire, pas d'intermédiaire, artisan diplômé identifiable.",
    neighbors: ["hirel", "la-fresnais", "cancale", "mont-dol"],
  },
  {
    slug: "saint-suliac",
    name: "Saint-Suliac",
    postal: "35430",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 14,
    lead:
      "Classé parmi les Plus Beaux Villages de France, Saint-Suliac attire résidents et touristes toute l'année. Nous intervenons pour toute urgence serrurerie sur les maisons de pêcheurs, résidences secondaires et locations saisonnières du village.",
    neighbors: ["saint-guinoux", "la-fresnais", "plerguer", "mont-dol"],
  },
  {
    slug: "saint-guinoux",
    name: "Saint-Guinoux",
    postal: "35430",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 8,
    lead:
      "Bourg rural entre Mont-Dol et Saint-Malo, Saint-Guinoux fait partie de notre zone d'intervention immédiate. Serrurerie 24h/24, dépannage rapide pour habitations et exploitations agricoles.",
    neighbors: ["la-fresnais", "saint-suliac", "mont-dol", "plerguer"],
  },
  {
    slug: "la-fresnais",
    name: "La Fresnais",
    postal: "35111",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 12,
    lead:
      "Commune résidentielle entre Cancale et la baie du Mont-Saint-Michel, La Fresnais bénéficie de notre intervention rapide. Ouverture de porte, changement de serrure, blindage — toutes prestations serrurerie sur RDV ou en urgence.",
    localSeo:
      "Située à mi-chemin entre Saint-Malo, Cancale et Dol-de-Bretagne, <strong>La Fresnais</strong> attire de nombreux jeunes ménages actifs qui apprécient son cadre calme et son accès rapide aux bassins d'emploi. La commune combine anciens noyaux villageois et lotissements récents, chacun avec ses spécificités serrurerie.\n\nDans les lotissements récents de La Fresnais, la majorité des portes sont équipées de <strong>serrures multipoints A2P</strong> — souvent des marques Bricard, Vachette, Héraclès ou Picard — que nous connaissons parfaitement et pour lesquelles nous disposons des cylindres compatibles en stock. Dans le bourg historique, les portes en bois massif nécessitent des interventions plus délicates, notamment pour préserver l'esthétique tout en modernisant la sécurité.\n\nNos interventions courantes : <strong>ouverture de porte en cas de perte de clés</strong>, changement de cylindre entre deux locations, <strong>mise en sécurité après tentative d'effraction</strong>, installation de serrures anti-panique pour les entreprises locales. Depuis Mont-Dol, intervention en <strong>20 minutes maximum</strong> à toute heure.",
    neighbors: ["saint-benoit-des-ondes", "saint-guinoux", "cancale", "hirel"],
  },
  {
    slug: "baguer-pican",
    name: "Baguer-Pican",
    postal: "35120",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 5,
    lead:
      "Commune limitrophe de Dol-de-Bretagne, Baguer-Pican est à moins de 10 minutes de notre atelier. Interventions immédiates pour tous types d'urgences serrurerie.",
    localSeo:
      "Située immédiatement à l'est de Dol-de-Bretagne, <strong>Baguer-Pican</strong> est traversée par la RN 176 qui relie la Bretagne au Cotentin. Cette proximité fait de la commune une zone résidentielle privilégiée pour les actifs travaillant à Saint-Malo, Dol ou Rennes, avec de nombreux pavillons récents et un centre-bourg ancien qui conserve son caractère breton.\n\nÀ Baguer-Pican, nos interventions serrurerie les plus courantes concernent les <strong>ouvertures de porte suite à perte de clés</strong>, particulièrement dans les zones pavillonnaires récentes où les serrures multipoints demandent une expertise spécifique. Les propriétaires de maisons anciennes du bourg nous sollicitent également pour la <strong>modernisation de portes traditionnelles</strong> et la mise à niveau de cylindres classiques vers des modèles anti-effraction A2P.\n\nNotre implantation à Mont-Dol étant à moins de 8 km, nous garantissons une intervention en <strong>15 à 20 minutes maximum</strong> sur toute la commune de Baguer-Pican (35120), y compris les hameaux excentrés. En cas d'urgence de nuit ou de week-end, un seul appel suffit — pas de plateforme intermédiaire, vous parlez directement à votre serrurier.",
    neighbors: ["dol-de-bretagne", "baguer-morvan", "mont-dol", "epiniac"],
  },
  {
    slug: "baguer-morvan",
    name: "Baguer-Morvan",
    postal: "35120",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 5,
    lead:
      "Village rural juste au sud de Dol-de-Bretagne, Baguer-Morvan est dans notre secteur d'intervention immédiat depuis Mont-Dol. Serrurerie 24h/24 pour particuliers et fermes.",
    localSeo:
      "Commune rurale d'Ille-et-Vilaine adossée à la voie ferrée Rennes–Saint-Malo, <strong>Baguer-Morvan</strong> est marquée par un tissu d'habitat pavillonnaire, de fermes en activité et de bâtiments d'exploitation agricole. Cette diversité crée des besoins serrurerie très variés : sécurisation de hangars agricoles, cylindres résistants aux intempéries pour dépendances, remplacement de serrures de portes en bois massif dans les longères traditionnelles.\n\nNous sommes régulièrement appelés à Baguer-Morvan pour des <strong>urgences serrurerie chez les exploitants agricoles</strong> (perte de trousseau, effraction sur locaux de stockage) où la rapidité d'intervention est critique. Nous intervenons également pour la <strong>rénovation de portes anciennes</strong> dans le centre-bourg, en préservant l'esthétique tout en modernisant la sécurité.\n\nDepuis Mont-Dol, Baguer-Morvan est à moins de 6 km — nous arrivons en <strong>15 minutes</strong> à toute heure du jour ou de la nuit. Aucun frais caché, aucun sous-traitant : un vrai artisan local qui connaît son territoire.",
    neighbors: ["dol-de-bretagne", "baguer-pican", "epiniac", "mont-dol"],
  },
  {
    slug: "epiniac",
    name: "Épiniac",
    postal: "35120",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 7,
    lead:
      "Commune rurale au sud de Dol-de-Bretagne, Épiniac fait partie du bassin de vie autour de Mont-Dol. Dépannage serrurerie rapide, tarifs identiques à ceux pratiqués sur toute la Côte d'Émeraude.",
    localSeo:
      "Village de l'arrière-pays dolois, <strong>Épiniac</strong> conjugue habitat rural traditionnel et lotissements résidentiels récents. La commune abrite plusieurs hameaux dispersés, ce qui peut compliquer l'intervention pour des serruriers non-locaux. Notre parfaite connaissance du territoire nous permet d'arriver rapidement, quel que soit le lieu-dit indiqué.\n\nÀ Épiniac, nous répondons à un mélange de demandes : <strong>ouvertures d'urgence après porte claquée</strong> pour les jeunes familles installées dans les lotissements, <strong>changements de serrures suite à séparation ou vente immobilière</strong>, et <strong>sécurisation de résidences secondaires</strong> restées inoccupées plusieurs semaines. Nos artisans savent également intervenir sur les portes anciennes en bois massif fréquentes dans les longères de la commune.\n\nDepuis Mont-Dol, Épiniac est à environ 8 km : intervention garantie en <strong>15 à 20 minutes</strong>. Un devis clair, annoncé par téléphone avant tout déplacement, et zéro surprise sur la facture.",
    neighbors: ["baguer-morvan", "baguer-pican", "dol-de-bretagne", "la-boussac"],
  },
  {
    slug: "roz-sur-couesnon",
    name: "Roz-sur-Couesnon",
    postal: "35610",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 9,
    lead:
      "Village de la baie du Mont-Saint-Michel offrant l'une des plus belles vues sur le Mont, Roz-sur-Couesnon est à quelques minutes de Mont-Dol. Intervention pour habitations, chambres d'hôtes et gîtes touristiques.",
    neighbors: ["saint-broladre", "pleine-fougeres", "cherrueix", "la-boussac"],
  },
  {
    slug: "pleine-fougeres",
    name: "Pleine-Fougères",
    postal: "35610",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 12,
    lead:
      "Bourg commerçant à l'est de la baie, Pleine-Fougères est dans notre zone d'intervention régulière. Serrurerie de proximité pour particuliers, commerces et professionnels.",
    neighbors: ["roz-sur-couesnon", "la-boussac", "mont-dol", "dol-de-bretagne"],
  },
  {
    slug: "la-boussac",
    name: "La Boussac",
    postal: "35120",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 9,
    lead:
      "Commune rurale au sud-est de Mont-Dol, La Boussac fait partie de notre zone d'intervention habituelle. Serrurerie 24h/24, tarifs justes annoncés avant chaque intervention.",
    localSeo:
      "Petit village breton typique, <strong>La Boussac</strong> se caractérise par son habitat dispersé entre bourg-centre, hameaux et fermes isolées. Cette configuration rurale rend beaucoup de serruriers nationaux inefficaces : ils facturent le déplacement au prix fort et perdent du temps à chercher les adresses. Notre implantation à Mont-Dol, à moins de 10 km, nous donne un avantage décisif de proximité et de connaissance terrain.\n\nÀ La Boussac, nos interventions typiques sont l'<strong>ouverture de porte pour retour de vacances</strong> (clé oubliée à l'intérieur), le <strong>changement de cylindre après cambriolage ou tentative</strong>, et l'installation de <strong>serrures multipoints haute sécurité</strong> pour les résidences principales isolées où le sentiment d'insécurité peut être plus fort qu'en ville.\n\nAppel direct au serrurier, pas de standard téléphonique national, devis annoncé au téléphone : c'est la garantie d'un tarif juste et d'une intervention en <strong>moins de 20 minutes</strong> sur toute la commune de La Boussac (35120).",
    neighbors: ["epiniac", "pleine-fougeres", "roz-sur-couesnon", "mont-dol"],
  },
  {
    slug: "roz-landrieux",
    name: "Roz-Landrieux",
    postal: "35120",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 6,
    lead:
      "Petit village limitrophe de Dol-de-Bretagne, Roz-Landrieux fait partie de notre zone d'intervention immédiate depuis Mont-Dol. Dépannage serrurerie 24h/24 pour habitations et exploitations agricoles.",
    localSeo:
      "Commune rurale de la baie du Mont-Saint-Michel, <strong>Roz-Landrieux</strong> combine habitat résidentiel, fermes en activité et hameaux historiques. Sa proximité immédiate avec Dol-de-Bretagne en fait un lieu de vie prisé des familles.\n\nÀ Roz-Landrieux, nos interventions courantes sont l'<strong>ouverture de porte suite à perte de clés</strong>, le <strong>remplacement de cylindres après cambriolage</strong>, et le <strong>renforcement des accès agricoles</strong>. Nous équipons aussi les habitations récentes en cylindres A2P adaptés aux serrures multipoints.\n\nDepuis Mont-Dol, Roz-Landrieux est à moins de 6 km : intervention en <strong>10 à 15 minutes</strong>, à toute heure. Tarif annoncé au téléphone, aucune surprise sur la facture.",
    neighbors: ["dol-de-bretagne", "mont-dol", "epiniac", "la-boussac"],
  },
  {
    slug: "saint-marcan",
    name: "Saint-Marcan",
    postal: "35120",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 8,
    lead:
      "Village perché offrant une vue exceptionnelle sur la baie et le Mont-Saint-Michel, Saint-Marcan attire résidents et touristes. Interventions serrurerie rapides pour habitations, gîtes et chambres d'hôtes.",
    localSeo:
      "Perché sur un promontoire face à la baie du Mont-Saint-Michel, <strong>Saint-Marcan</strong> bénéficie d'une situation touristique privilégiée. Le village accueille chambres d'hôtes, gîtes et résidences secondaires en nombre.\n\nÀ Saint-Marcan, nous intervenons pour l'<strong>installation de boîtes à clés sécurisées</strong> pour les propriétaires louant sur Airbnb/Booking, l'<strong>ouverture de porte en urgence</strong> pour les voyageurs bloqués et le <strong>renforcement de portes anciennes</strong> dans le centre-bourg. Notre expertise sur les serrures exposées au vent marin est un vrai plus.\n\nDepuis Mont-Dol, Saint-Marcan est à 8 km : nous arrivons en <strong>15 à 20 minutes</strong>, y compris la nuit et le week-end. Aucun intermédiaire, un artisan local qui répond directement.",
    neighbors: ["roz-sur-couesnon", "saint-broladre", "mont-dol", "la-boussac"],
  },
  {
    slug: "lillemer",
    name: "Lillemer",
    postal: "35111",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 8,
    lead:
      "L'une des plus petites communes d'Ille-et-Vilaine, Lillemer conserve un charme rural authentique. Serrurerie 24h/24 pour toutes urgences sur la commune.",
    localSeo:
      "Petite commune située entre Mont-Dol et Saint-Malo, <strong>Lillemer</strong> est un havre de calme apprécié pour son cadre préservé et ses maisons traditionnelles en pierre. La commune reste peu couverte par les serruriers locaux — ce qui provoque souvent des interventions tardives quand un problème survient.\n\nMon Serrurier Breton est votre <strong>artisan de proximité à Lillemer</strong>, joignable directement, sans passer par une plateforme. Interventions typiques : <strong>ouverture de porte claquée</strong>, <strong>remplacement de serrure ancienne</strong> en préservant l'esthétique de la porte, et <strong>installation de cylindres haute sécurité</strong> sur les habitations principales.\n\nDepuis Mont-Dol, Lillemer est à 8 km — arrivée garantie en <strong>15 minutes</strong>. Devis clair et tarifs identiques à ceux appliqués dans toutes nos communes.",
    neighbors: ["saint-guinoux", "mont-dol", "la-fresnais", "plerguer"],
  },
  {
    slug: "plerguer",
    name: "Plerguer",
    postal: "35540",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 12,
    lead:
      "Commune résidentielle entre Dol et Saint-Malo, Plerguer est bien desservie et attire de nombreux actifs. Intervention serrurerie 24h/24 en 20 minutes maximum.",
    localSeo:
      "Bourg d'Ille-et-Vilaine bien desservi par la RN176, <strong>Plerguer</strong> est en pleine expansion résidentielle. La commune compte nombre de lotissements récents, un tissu commerçant dynamique et plusieurs zones d'activité.\n\nÀ Plerguer, nous répondons à un large éventail de demandes serrurerie : <strong>ouvertures d'urgence dans les lotissements</strong> (serrures multipoints modernes), <strong>maintenance de fermetures pour les commerces</strong> (rideaux métalliques, portes anti-panique), et <strong>sécurisation de logements</strong> à louer pour les agences immobilières.\n\nDepuis Mont-Dol, Plerguer est à 12 km — intervention en <strong>20 minutes maximum</strong>, avec le stock complet de cylindres Bricard, Vachette, Héraclès et Picard disponibles à bord.",
    neighbors: ["miniac-morvan", "saint-guinoux", "lillemer", "chateauneuf-d-ille-et-vilaine"],
  },
  {
    slug: "miniac-morvan",
    name: "Miniac-Morvan",
    postal: "35540",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 14,
    lead:
      "Commune commerçante sur l'axe Saint-Malo–Rennes, Miniac-Morvan bénéficie d'une position stratégique. Serrurier 24h/24 pour particuliers et professionnels.",
    localSeo:
      "Située à l'intersection de la RN137 et de la RD794, <strong>Miniac-Morvan</strong> combine une identité rurale et une forte activité commerciale. La commune compte un pôle de services et de commerces qui rayonne bien au-delà de ses limites administratives.\n\nNos interventions à Miniac-Morvan concernent aussi bien les <strong>particuliers en urgence</strong> (porte claquée, clé perdue) que les <strong>professionnels locaux</strong> (installateurs, commerces, agences). Nous intervenons sur les <strong>rideaux métalliques de commerces</strong>, les <strong>serrures anti-panique</strong> obligatoires en ERP, et les <strong>coffres-forts</strong>.\n\nDepuis Mont-Dol, Miniac-Morvan est à 14 km : nous arrivons en <strong>20 à 25 minutes</strong>. Facture claire acceptée par toutes les assurances habitation.",
    neighbors: ["plerguer", "le-tronchet", "chateauneuf-d-ille-et-vilaine", "saint-guinoux"],
  },
  {
    slug: "le-tronchet",
    name: "Le Tronchet",
    postal: "35540",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 18,
    lead:
      "Bordée par la forêt et le lac du Mireloup, la commune du Tronchet est un havre de nature. Interventions serrurerie rapides pour habitations, gîtes et résidences de vacances.",
    localSeo:
      "Commune boisée entre Dol-de-Bretagne et Combourg, <strong>Le Tronchet</strong> est célèbre pour son abbaye, son golf et son cadre forestier exceptionnel. La commune attire de nombreux propriétaires de résidences secondaires et gîtes ruraux.\n\nAu Tronchet, nos interventions les plus fréquentes sont la <strong>sécurisation de résidences secondaires</strong> restées vacantes plusieurs semaines, le <strong>changement de serrures</strong> après achat immobilier, et l'<strong>ouverture de portes anciennes</strong> dans les longères en pierre du bourg. Nous équipons également les gîtes en <strong>boîtes à clés sécurisées</strong> pour la gestion locative.\n\nDepuis Mont-Dol, Le Tronchet est à 18 km : intervention en <strong>25 à 30 minutes</strong>. Un artisan local qui connaît les spécificités du territoire.",
    neighbors: ["miniac-morvan", "bonnemain", "lanhelin-mesnil-roch", "plerguer"],
  },
  {
    slug: "bonnemain",
    name: "Bonnemain",
    postal: "35270",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 20,
    lead:
      "Village de l'arrière-pays entre Dol et Combourg, Bonnemain est dans notre zone d'intervention régulière. Serrurerie complète : ouverture, changement de serrure, blindage.",
    localSeo:
      "Bourg rural du canton de Combourg, <strong>Bonnemain</strong> compte un mélange harmonieux d'habitat traditionnel breton et de lotissements récents. La commune connaît une forte demande d'installations sécuritaires depuis l'expansion résidentielle des dernières années.\n\nÀ Bonnemain, nous intervenons pour l'<strong>installation de serrures multipoints A2P</strong> sur les portes d'entrée neuves, la <strong>rénovation de portes anciennes</strong> dans les longères historiques, et les <strong>urgences classiques</strong> (porte claquée, clé perdue, effraction). Les commerces locaux nous confient également l'audit annuel de leurs fermetures.\n\nDepuis Mont-Dol, Bonnemain est à 20 km : intervention en <strong>25 à 30 minutes</strong>. Devis annoncé au téléphone, tarifs justes, artisan diplômé identifiable.",
    neighbors: ["le-tronchet", "lourmais", "lanhelin-mesnil-roch", "epiniac"],
  },
  {
    slug: "saint-pere-marc-en-poulet",
    name: "Saint-Père-Marc-en-Poulet",
    postal: "35430",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 14,
    lead:
      "Commune née de la fusion de Saint-Père et Marc-en-Poulet, à quelques minutes de Saint-Malo. Serrurier local pour particuliers, agences immobilières et bailleurs.",
    localSeo:
      "<strong>Saint-Père-Marc-en-Poulet</strong>, née de la fusion en 2019 de Saint-Père et de Marc-en-Poulet, est aujourd'hui une commune résidentielle prisée pour sa proximité avec Saint-Malo et son cadre calme. Le tissu pavillonnaire y est important, avec de nombreux lotissements des années 1990 à 2020.\n\nÀ Saint-Père-Marc-en-Poulet, nos interventions courantes sont le <strong>changement de cylindre entre deux locataires</strong> (nombreuses maisons en location gérées par des agences malouines), la <strong>mise à niveau de portes d'entrée</strong> vers des modèles multipoints certifiés A2P, et les <strong>ouvertures d'urgence</strong> 24h/24.\n\nDepuis Mont-Dol, la commune est à 14 km : intervention en <strong>20 minutes</strong>, sans facturation cachée et sans plateforme intermédiaire.",
    neighbors: ["chateauneuf-d-ille-et-vilaine", "saint-jouan-des-guerets", "saint-guinoux", "plerguer"],
  },
  {
    slug: "chateauneuf-d-ille-et-vilaine",
    name: "Châteauneuf-d'Ille-et-Vilaine",
    postal: "35430",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 13,
    lead:
      "Commune située sur les hauteurs de la Rance, à 10 minutes de Saint-Malo. Serrurier 24h/24 pour habitations principales, résidences secondaires et professionnels.",
    localSeo:
      "Situé au sud de l'estuaire de la Rance, <strong>Châteauneuf-d'Ille-et-Vilaine</strong> combine bourg historique, hameaux et pavillons récents. La commune bénéficie d'un accès rapide à Saint-Malo, ce qui en fait un lieu de résidence prisé.\n\nÀ Châteauneuf-d'Ille-et-Vilaine, nos interventions couvrent tout le spectre serrurerie : <strong>urgences 24h/24</strong> (porte claquée, tentative d'effraction), <strong>installations de serrures multipoints</strong> sur portes en bois massif, <strong>rénovation de cylindres oxydés</strong> par l'air marin dans les habitations les plus exposées à la Rance.\n\nDepuis Mont-Dol, Châteauneuf est à 13 km : intervention en <strong>20 minutes</strong>. Nous privilégions systématiquement l'ouverture sans casse quand la situation le permet.",
    neighbors: ["saint-pere-marc-en-poulet", "miniac-morvan", "plerguer", "saint-jouan-des-guerets"],
  },
  {
    slug: "la-gouesniere",
    name: "La Gouesnière",
    postal: "35350",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 15,
    lead:
      "Commune desservie par le TER Saint-Malo–Dol, La Gouesnière attire nombre d'actifs. Serrurier local, tarifs justes, intervention 24h/24 en 20 minutes.",
    localSeo:
      "Village de la baie proche de Cancale et Saint-Malo, <strong>La Gouesnière</strong> bénéficie d'une desserte ferroviaire TER qui en fait un lieu de vie très recherché. La commune combine habitat pavillonnaire, fermes en activité et centre-bourg historique.\n\nÀ La Gouesnière, nos interventions serrurerie les plus demandées sont l'<strong>ouverture d'urgence pour retour de vacances</strong>, le <strong>changement de serrure suite à cambriolage</strong>, et l'<strong>installation de cylindres haute sécurité</strong> pour les logements loués aux navetteurs travaillant à Saint-Malo ou Rennes.\n\nDepuis Mont-Dol, La Gouesnière est à 15 km : intervention en <strong>20 à 25 minutes</strong>. Facture acceptée par toutes les compagnies d'assurance habitation.",
    neighbors: ["saint-meloir-des-ondes", "saint-benoit-des-ondes", "la-fresnais", "cancale"],
  },
  {
    slug: "saint-meloir-des-ondes",
    name: "Saint-Méloir-des-Ondes",
    postal: "35350",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 17,
    lead:
      "Commune agricole proche de Cancale, réputée pour ses cultures maraîchères et légumières. Serrurier 24h/24 pour particuliers et professionnels.",
    localSeo:
      "Célèbre pour ses cultures maraîchères en bord de mer, <strong>Saint-Méloir-des-Ondes</strong> est une commune dynamique aux portes de Cancale. Le tissu économique local — exploitations agricoles, ostréiculteurs, artisans, commerces — nous fait intervenir sur des besoins très variés.\n\nÀ Saint-Méloir-des-Ondes, nous équipons les <strong>locaux professionnels agricoles et maraîchers</strong> (serrures anti-effraction, cylindres résistants à l'humidité), nous <strong>sécurisons les résidences secondaires</strong> nombreuses sur le littoral, et nous intervenons en <strong>urgence 24h/24</strong> pour les particuliers.\n\nDepuis Mont-Dol, la commune est à 17 km : intervention en <strong>25 minutes</strong>. Artisan local, pas d'intermédiaire, tarifs identiques à ceux pratiqués partout ailleurs.",
    neighbors: ["cancale", "la-gouesniere", "saint-coulomb", "saint-benoit-des-ondes"],
  },
  {
    slug: "sains",
    name: "Sains",
    postal: "35610",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 15,
    lead:
      "Petit village rural entre Dol-de-Bretagne et Pontorson, Sains est dans notre zone d'intervention régulière. Serrurier local, tarifs transparents.",
    localSeo:
      "Bourg rural de la baie du Mont-Saint-Michel, <strong>Sains</strong> compte quelques centaines d'habitants dans un cadre paisible. La commune est peu couverte par les serruriers locaux, ce qui laisse aux plateformes nationales le champ libre pour facturer des interventions au prix fort.\n\nMon Serrurier Breton est votre <strong>artisan local à Sains</strong>, joignable directement, sans standard téléphonique national. Interventions courantes : <strong>ouverture de porte</strong> après perte de clés, <strong>remplacement de serrure ancienne</strong> dans les longères, et <strong>sécurisation d'habitations</strong> avant absence prolongée.\n\nDepuis Mont-Dol, Sains est à 15 km : intervention garantie en <strong>25 minutes</strong>. Devis annoncé au téléphone, tarifs justes, aucun sous-traitant.",
    neighbors: ["pleine-fougeres", "roz-sur-couesnon", "la-boussac", "pontorson"],
  },
  {
    slug: "lanhelin-mesnil-roch",
    name: "Lanhélin (Mesnil-Roc'h)",
    postal: "35720",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 24,
    lead:
      "Commune déléguée de Mesnil-Roc'h, Lanhélin est un village breton typique. Serrurier 24h/24, intervention dans un délai raisonnable.",
    localSeo:
      "Commune déléguée au sein de <strong>Mesnil-Roc'h</strong>, <strong>Lanhélin</strong> conserve son identité de village breton avec son centre-bourg de granit et son habitat rural préservé. La commune est éloignée des centres urbains, ce qui rend la présence d'un serrurier local particulièrement précieuse.\n\nÀ Lanhélin, nos interventions serrurerie concernent principalement l'<strong>ouverture de portes anciennes</strong> qui demandent une expertise particulière, le <strong>changement de serrures</strong> suite à achat immobilier, et le <strong>renforcement d'accès</strong> pour les résidences isolées.\n\nDepuis Mont-Dol, Lanhélin est à 24 km : intervention en <strong>30 à 35 minutes</strong>. Devis clair, sans sous-traitant, tarifs alignés sur nos tarifs habituels.",
    neighbors: ["tresse-mesnil-roch", "le-tronchet", "bonnemain", "lourmais"],
  },
  {
    slug: "tresse-mesnil-roch",
    name: "Tressé (Mesnil-Roc'h)",
    postal: "35720",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 22,
    lead:
      "Commune déléguée de Mesnil-Roc'h célèbre pour ses mégalithes, Tressé est dans notre zone d'intervention. Serrurier local, intervention rapide.",
    localSeo:
      "Connue pour ses mégalithes néolithiques, <strong>Tressé</strong> est une commune déléguée de <strong>Mesnil-Roc'h</strong> qui allie patrimoine préhistorique et habitat rural traditionnel. Le village compte peu d'habitants mais une belle activité touristique liée à ses monuments.\n\nÀ Tressé, nos interventions serrurerie couvrent aussi bien les <strong>habitations principales</strong> que les <strong>gîtes touristiques</strong> et <strong>chambres d'hôtes</strong>. Nos prestations les plus courantes : ouverture de porte 24h/24, installation de <strong>boîtes à clés sécurisées</strong>, remplacement de cylindres, sécurisation de dépendances agricoles.\n\nDepuis Mont-Dol, Tressé est à 22 km : intervention en <strong>30 minutes</strong>. Pas de plateforme, un vrai artisan qui connaît le territoire.",
    neighbors: ["lanhelin-mesnil-roch", "le-tronchet", "bonnemain", "lourmais"],
  },
  {
    slug: "lourmais",
    name: "Lourmais",
    postal: "35270",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 22,
    lead:
      "Village rural du canton de Combourg, Lourmais est dans notre zone d'intervention. Serrurier local sans plateforme intermédiaire.",
    localSeo:
      "Petite commune rurale de l'arrière-pays dolois, <strong>Lourmais</strong> compte moins de 200 habitants dans un cadre bucolique. La commune n'est pas couverte par un serrurier local, ce qui expose ses habitants aux dérives des plateformes nationales : appels surtaxés, tarifs opaques, artisans qui refacturent à leur guise.\n\nMon Serrurier Breton est votre <strong>alternative locale à Lourmais</strong> : appel direct, devis annoncé au téléphone, tarif identique à celui pratiqué à Mont-Dol ou Dol. Interventions courantes : ouverture de porte, changement de serrure, sécurisation d'habitations, réparation de portes anciennes.\n\nDepuis Mont-Dol, Lourmais est à 22 km : intervention en <strong>30 à 35 minutes</strong>. Devis clair, aucun frais caché.",
    neighbors: ["bonnemain", "lanhelin-mesnil-roch", "tresse-mesnil-roch", "epiniac"],
  },
  {
    slug: "saint-jouan-des-guerets",
    name: "Saint-Jouan-des-Guérets",
    postal: "35430",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 17,
    lead:
      "Commune sur les rives de la Rance, à 5 minutes de Saint-Malo, Saint-Jouan-des-Guérets est un lieu de vie prisé. Serrurier local, intervention 24h/24.",
    localSeo:
      "Situé sur la rive gauche de la Rance, <strong>Saint-Jouan-des-Guérets</strong> combine cadre naturel exceptionnel et proximité immédiate de Saint-Malo. Le tissu résidentiel est dense, avec de nombreux pavillons récents et un vieux bourg pittoresque.\n\nÀ Saint-Jouan-des-Guérets, nos interventions les plus fréquentes sont le <strong>changement de serrure haute sécurité</strong> sur les portes des maisons donnant sur la Rance (souvent visées par les cambriolages), l'<strong>ouverture d'urgence</strong> pour les habitants qui reviennent d'une balade en bord de Rance sans leurs clés, et la <strong>mise en sécurité après effraction</strong>.\n\nDepuis Mont-Dol, la commune est à 17 km : intervention en <strong>25 minutes</strong>. Facture claire, sans surprise, acceptée par toutes les compagnies d'assurance.",
    neighbors: ["saint-pere-marc-en-poulet", "saint-suliac", "chateauneuf-d-ille-et-vilaine", "plerguer"],
  },
  {
    slug: "saint-coulomb",
    name: "Saint-Coulomb",
    postal: "35350",
    departement: "Ille-et-Vilaine",
    dept: "35",
    distance: 22,
    lead:
      "Commune littorale célèbre pour la Pointe du Grouin et ses plages, Saint-Coulomb attire résidents et vacanciers. Serrurier 24h/24 pour résidences principales, secondaires et locations saisonnières.",
    localSeo:
      "Située entre Saint-Malo et Cancale, <strong>Saint-Coulomb</strong> est célèbre pour ses plages, la Pointe du Grouin et ses maisons de pêcheurs pittoresques. Le tourisme et les résidences secondaires y sont particulièrement importants.\n\nÀ Saint-Coulomb, nos interventions serrurerie ciblent trois publics : les <strong>propriétaires de résidences secondaires</strong> qui découvrent un problème de fermeture à leur arrivée, les <strong>conciergeries et gestionnaires Airbnb</strong> qui nous confient l'entretien et la mise à niveau des serrures, et les <strong>habitants permanents</strong> pour les urgences classiques 24h/24.\n\nNous équipons systématiquement les habitations proches de la côte avec des <strong>cylindres inox anti-corrosion</strong> pour résister à l'air marin. Depuis Mont-Dol, Saint-Coulomb est à 22 km : intervention en <strong>30 minutes</strong>.",
    neighbors: ["cancale", "saint-meloir-des-ondes", "la-gouesniere", "saint-benoit-des-ondes"],
  },
  {
    slug: "mont-saint-michel",
    name: "Le Mont-Saint-Michel",
    postal: "50170",
    departement: "Manche",
    dept: "50",
    distance: 25,
    lead:
      "Célèbre baie et Merveille de l'Occident, le Mont-Saint-Michel accueille commerces, restaurants et hôtels au pied du Mont. Nous intervenons pour toutes urgences serrurerie sur la commune.",
    localSeo:
      "Site classé au patrimoine mondial de l'UNESCO, <strong>Le Mont-Saint-Michel</strong> et ses abords accueillent une activité touristique et commerciale intense. La commune compte hôtels, restaurants, boutiques et logements pour les habitants et professionnels du site.\n\nAu Mont-Saint-Michel, nos interventions serrurerie couvrent essentiellement les <strong>professionnels de l'hôtellerie et de la restauration</strong> : ouverture de chambres, remplacement de cylindres entre deux saisons, sécurisation de commerces, dépannage de rideaux métalliques. La configuration unique du site (accès piéton, marées) impose une organisation adaptée.\n\nBien que situé dans la Manche (50), le Mont-Saint-Michel est à <strong>25 km de Mont-Dol</strong> : intervention en 30 à 40 minutes selon la circulation. Contactez-nous directement pour toute urgence, nous coordonnons avec la mairie et les services du site.",
    neighbors: ["pontorson", "saint-marcan", "sains", "roz-sur-couesnon"],
  },
  {
    slug: "pontorson",
    name: "Pontorson",
    postal: "50170",
    departement: "Manche",
    dept: "50",
    distance: 22,
    lead:
      "Porte du Mont-Saint-Michel, Pontorson est un bourg commerçant dynamique de la Manche. Serrurier 24h/24 pour habitations, commerces et professionnels du tourisme.",
    localSeo:
      "Bourg commerçant de la Manche adossé à la baie du Mont-Saint-Michel, <strong>Pontorson</strong> est la porte d'entrée du site classé. La commune compte de nombreux commerces, hôtels et gîtes qui rayonnent sur la baie.\n\nÀ Pontorson, nous intervenons pour toutes les demandes serrurerie : <strong>dépannage d'urgence 24h/24</strong> pour les particuliers, <strong>maintenance des fermetures</strong> pour les commerces (rideaux métalliques, portes anti-panique), <strong>gestion serrurerie des hôtels et gîtes</strong> touristiques (organigrammes, boîtes à clés). Notre expertise dans l'hôtellerie de la baie MSM est unique dans le secteur.\n\nBien que située dans la Manche (50), Pontorson est à <strong>22 km de Mont-Dol</strong> : intervention en 30 minutes. Facturation pro pour les professionnels, tarif clair pour les particuliers.",
    neighbors: ["mont-saint-michel", "sains", "pleine-fougeres", "saint-marcan"],
  },
];

export const INTERVENTION_CITIES = CITIES.map((c) => c.name);

export const ARTISAN_PHOTO =
  "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/dh4vxp26_serrurier%20ploubalay.png";

export const ARTISAN_BADGE =
  "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/fn0h4775_Noir%20et%20Orange%20Simple%20Internet%20Logo%20%289%29.avif";

export const TRUCK_IMAGE =
  "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/jhzxk2bf_unnamed-removebg-preview.avif";

export const ARTISAN = {
  firstname: "Votre artisan",
  fullname: "Mon Serrurier Breton",
  role: "Artisan serrurier diplômé",
  yearsXp: 8,
  intro:
    "Bonjour, je suis François, votre serrurier breton. Basé à Mont-Dol, en plein cœur de la baie du Mont-Saint-Michel, j'interviens chaque jour chez les particuliers et les professionnels du secteur 22 & 35 pour des dépannages, des changements de serrure et des travaux de sécurité. Mon engagement : un travail soigné, des tarifs transparents annoncés avant chaque intervention, et zéro surprise.",
};

export const INSURANCE_PARTNERS = [
  {
    name: "AXA",
    logo: "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/lpv4ghmk_AXA_Logo.svg.png",
  },
  {
    name: "MAIF",
    logo: "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/8c4dp1lr_MAIF.png",
  },
  {
    name: "MMA",
    logo: "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/v15n7xjz_logo_mma_transparent.png",
  },
  {
    name: "MACIF",
    logo: "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/r6q9p2v0_MACIF_logo.svg.png",
  },
  {
    name: "Crédit Agricole",
    logo: "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/q3ggo1w5_Cre%CC%81dit_Agricole.svg.png",
  },
  {
    name: "Allianz",
    logo: "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/02cwh68b_Allianz.svg.png",
  },
  {
    name: "Groupama",
    logo: "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/9xpwjngt_Logo_Groupama_2024.svg.png",
  },
  {
    name: "Matmut",
    logo: "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/dp8ayx13_Logo_MATMUT_2022.svg.png",
  },
];

export const FAQ = [
  {
    q: "Combien coûte une ouverture de porte claquée ?",
    a: "L'ouverture d'une porte claquée en journée coûte 100 € TTC. Si la porte est fermée à clé, le tarif passe à 130 €. Pour une porte blindée claquée, comptez 150 €, et 250 € si elle est blindée et fermée à clé. Le déplacement est facturé 50 € en forfait. Le prix est annoncé et validé avant chaque intervention.",
  },
  {
    q: "Combien de temps pour intervenir chez moi ?",
    a: "Nous intervenons en moyenne en 30 minutes sur tout le secteur Mont-Dol / Côte d'Émeraude et un rayon d'environ 30 km autour de Mont-Dol (départements 22 et 35). Le délai exact vous est communiqué dès l'appel.",
  },
  {
    q: "Allez-vous casser ma serrure pour ouvrir ma porte ?",
    a: "Non. Nous privilégions toujours l'ouverture fine (non destructive) qui préserve votre serrure. Le crochetage ou les techniques manuelles permettent d'ouvrir la majorité des portes sans aucun dégât. Le perçage n'est utilisé qu'en dernier recours, et uniquement avec votre accord explicite.",
  },
  {
    q: "Travaillez-vous la nuit, le week-end et les jours fériés ?",
    a: "Oui, nous sommes disponibles 24h/24 et 7j/7, y compris les nuits, week-ends et jours fériés. Les majorations applicables sont : +30 % entre 18h30 et 21h, +50 % après 21h, et +50 % les dimanches et jours fériés. Tous nos tarifs sont annoncés avant l'intervention.",
  },
  {
    q: "Êtes-vous un vrai artisan ou un réseau d'intermédiaires ?",
    a: "Mon Serrurier Breton est un véritable artisan local, basé à Mont-Dol. Aucun intermédiaire, aucun centre d'appels : vous échangez directement avec votre serrurier. C'est ce qui nous permet de pratiquer des tarifs justes et de garantir la qualité d'intervention.",
  },
  {
    q: "Acceptez-vous les remboursements assurance ?",
    a: "Oui. Nous fournissons systématiquement une facture détaillée acceptée par la quasi-totalité des compagnies d'assurance (MAIF, MMA, AXA, MACIF, Crédit Agricole, Groupama, Allianz, Matmut, etc.) pour le remboursement de vos frais de serrurerie après effraction ou dépannage.",
  },
  {
    q: "Quel mode de paiement acceptez-vous ?",
    a: "Le paiement est exigé immédiatement à l'issue de la prestation. Nous acceptons espèces, carte bancaire et chèque. Le matériel installé reste la propriété de l'entreprise jusqu'au paiement intégral.",
  },
  {
    q: "Puis-je avoir un devis avant l'intervention ?",
    a: "Oui, et c'est gratuit. Le tarif vous est annoncé par téléphone à la prise de rendez-vous, puis confirmé sur place avant tout démarrage. Aucun travail n'est commencé sans votre accord clair sur le prix.",
  },
  {
    q: "Quelles marques de serrures et cylindres installez-vous ?",
    a: "Nous travaillons exclusivement avec des marques certifiées et reconnues : Picard, Vachette, Bricard, Héraclès, Assa Abloy, Mul-T-Lock, Fichet. Cela garantit la durabilité de l'installation et sa conformité aux exigences des assurances (notamment certification A2P).",
  },
  {
    q: "Intervenez-vous dans toutes les communes du 22 et du 35 ?",
    a: "Notre périmètre principal couvre un rayon de 30 km autour de Mont-Dol (35120) : Dol-de-Bretagne, Le Vivier-sur-Mer, Saint-Malo, Dinard, Dinan, Cancale, Plancoët, Matignon, Saint-Cast-le-Guildo, Ploubalay et toutes les communes intermédiaires. Pour les communes plus éloignées, appelez-nous, nous nous arrangeons souvent à intervenir.",
  },
];

export const INTERVENTION_PHOTOS = [
  {
    url: "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/mk20itpd_32fadf_27a26158b98e48fb9a49531698af836f~mv2.avif",
    caption: "Installation d'éléments anti-effraction",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/ljgxm7h9_32fadf_a33dc83589d94bbea5c57ff5733856f4~mv2.avif",
    caption: "Serrure encastrée à larder",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/yisaup6p_32fadf_d41adc5b19254e00bdabde903c95b1ee~mv2.avif",
    caption: "Pose d'une serrure carénée",
  },
];

export const BRAND_DETAILS = [
  {
    name: "PICARD",
    logo: "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/ilhqclgj_logo%2BPicard%2BSerrures.jpg",
    tag: "Serrures & portes blindées",
    desc: "Référence française en serrures haute sécurité et portes blindées certifiées A2P.",
  },
  {
    name: "VACHETTE",
    logo: "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/ejnijjd2_Vachette-logo.jpg",
    tag: "Cylindres & serrures",
    desc: "Spécialiste reconnu des cylindres et serrures domestiques fiables et durables.",
  },
  {
    name: "ASSA ABLOY",
    logo: "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/fb605y8j_assay%20abloy.png",
    tag: "Solutions de sécurité",
    desc: "Leader mondial de la sécurité avec des technologies avancées pour habitats et pros.",
  },
  {
    name: "HÉRACLÈS",
    logo: "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/6yc7gu35_heracles.jpeg",
    tag: "Cylindres anti-crochetage",
    desc: "Expert en cylindres haute sécurité, protection avancée contre les techniques d'effraction.",
  },
  {
    name: "BRICARD",
    logo: "https://customer-assets.emergentagent.com/job_urgence-serrurier/artifacts/0ncem9vq_BRICARD%20SERRURE.png",
    tag: "Serrurerie haute sûreté",
    desc: "Marque historique française, cylindres et serrures haut de gamme anti-effraction.",
  },
];

export const INTERVENTION_TYPES = [
  "Ouverture de porte",
  "Changement de serrure",
  "Mise en sécurité après effraction",
  "Blindage / renfort",
  "Boîte aux lettres",
  "Autre / Conseil",
];
